import React from "react";
import { useLocation } from "react-router-dom";
import { getAnalyticsConsent, initializeAnalytics, isAnalyticsConfigured, setAnalyticsConsent, trackPageView } from "../lib/analytics";

export const AnalyticsConsent = () => {
  const { pathname } = useLocation();
  const configured = isAnalyticsConfigured();
  const [consent, setConsent] = React.useState(() => getAnalyticsConsent());

  React.useEffect(() => {
    let active = true;
    if (!configured || consent !== "accepted") return () => { active = false; };
    initializeAnalytics().then((ready) => {
      if (active && ready) trackPageView(pathname);
    });
    return () => { active = false; };
  }, [configured, consent, pathname]);

  if (!configured || consent) return null;

  const choose = (value) => {
    setAnalyticsConsent(value);
    setConsent(value);
  };

  return (
    <aside
      role="dialog"
      aria-labelledby="analytics-consent-title"
      aria-describedby="analytics-consent-description"
      className="fixed inset-x-4 bottom-4 z-[80] mx-auto max-w-2xl rounded-lg border border-white/[0.12] bg-[#101215] p-4 shadow-2xl sm:flex sm:items-center sm:gap-5"
    >
      <div className="min-w-0 flex-1">
        <h2 id="analytics-consent-title" className="text-sm font-semibold text-white">Optional usage analytics</h2>
        <p id="analytics-consent-description" className="mt-1 text-xs leading-5 text-zinc-400">
          Allow anonymous route-level page views to help improve LONGVIEW. Portfolio entries and research questions are never included.
        </p>
      </div>
      <div className="mt-3 flex shrink-0 gap-2 sm:mt-0">
        <button type="button" onClick={() => choose("rejected")} className="lv-press rounded-md border border-white/[0.1] px-3 py-2 font-mono text-[11px] text-zinc-300 hover:border-white/20">
          Reject
        </button>
        <button type="button" onClick={() => choose("accepted")} className="lv-press rounded-md border border-amber-500/30 bg-amber-500/10 px-3 py-2 font-mono text-[11px] text-amber-300 hover:bg-amber-500/20">
          Accept
        </button>
      </div>
    </aside>
  );
};
